import styled from 'styled-components';
import { respondTo } from '../../common/styles/mixins';
import * as colors from '../../common/styles/colors';

export const DocumentRepositoryModalWrapper = styled.div`
  .modal-title {
    color: ${colors.hydroBlue};
  }

  .rmdp-input {
    height: 40px;
  }
`;

export const DocumentRepositoryWrapper = styled.div`
  padding: 0 1rem 1rem;

  ${respondTo.tablet`
    margin: 0;
    padding: 0 33px 33px 0;
  `}

  .static-text {
    text-align: center;

    ${respondTo.tablet`
        text-align: left;
      `};
  }

  a {
    color: ${({ theme }) => theme.text.secondary};
    text-decoration: none;
  }
`;

export const DocumentRepositoryGridWrapper = styled.div`
  overflow-y: auto;
  height: 90%;

  .table-responsive {
    min-height: 0px;
  }

  td.acc-refs-col {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
